import React from 'react';
import TryhardNav from './Nav/TryhardNav';
import { AnimatePresence, motion } from 'motion/react';
import { SiteTransitions } from '../../../utils/transitions';
import TryhardFooter from './Footer/TryhardFooter';
import TryhardCarousel from './Body/TryhardCarousel';
import { Outlet } from 'react-router';
import TryhardMerchNotice from './Body/TryhardMerchNotice';

// Partners, Products, About, Services, Contact, FAQ,

const TryhardMain: React.FC = () => {
    return (
        <motion.div
            variants={SiteTransitions}
            initial='initial'
            animate='animate'
            exit='exit'
            className='flex flex-col size-full'
        >
            <TryhardNav />
            <main
                className='grow flex flex-col'
            >
                <TryhardCarousel />
                <AnimatePresence mode='wait'>
                    <Outlet />
                </AnimatePresence>
                <TryhardMerchNotice />
            </main>
            <TryhardFooter />
        </motion.div>
    )
}

export default TryhardMain;